import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';

interface ConfirmDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    message: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ open, onClose, title, message }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
            maxWidth="sm" // Limitar o tamanho máximo da largura do diálogo
        >
            <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent
                sx={{
                    maxHeight: '400px', // Definindo um limite de altura para a área de conteúdo
                    overflowY: 'auto', // Adicionando rolagem quando o conteúdo exceder a altura
                }}
            >
                <Typography id="confirm-dialog-description" variant="body1" paragraph>
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
